export default __webpack_public_path__ + "static/media/iphone.d908eede.png";